module.exports = __webpack_public_path__ + "media/images/corefl_simple_search-7f9fb0ccba3e34efd43df10f202a696d.gif";